import { ROUTE_OPERATOR_TYPE_PAGE_API } from '../config/apiPoints';
import { fetchHelper } from '../../utils/fetchHelper';

export const prepareRouteOperatorTypePageRequest = (params) => {
    const { src, dest, operator, operatorId, bus_type } = params;
    let slug = `${operator}-buses-${bus_type}-from-${src}-to-${dest}-online-bus-${operatorId ? operatorId : ''}`;
    const url = `${__ENV_CONFIG__.__PAGEROVER__}${ROUTE_OPERATOR_TYPE_PAGE_API}?slug=${slug}`
    return url;
}

export const getRouteOperatorTypePageData = async (params) => {
    const url = prepareRouteOperatorTypePageRequest(params);
    let data = {}
    try {
        data = await fetchHelper({
            name: 'route operator type page',
            type: 'GET',
            url: url,
        });
    } catch (err) {
        data = { status: false, error: true }
    }
    return data;
}
